import type { BenchmarkRate } from '@/types';

/**
 * Currency → standard floating benchmark for the rate selectors.
 * LR-443: tonar/honia are not offered for now, so JPY/HKD have no standard
 * benchmark — default to 'other' (trader sets the rate manually).
 *
 * Lives in a leaf module so the extracted trade-form effect hooks and
 * useCreateTradeForm can both import it without a circular dependency (LR-495).
 */
export const getDefaultBenchmarkByCurrency = (currency: string): BenchmarkRate => {
  switch (currency) {
    case 'EUR':
      return 'estr';
    case 'GBP':
      return 'sonia';
    case 'JPY':
    case 'HKD':
      return 'other';
    default:
      return 'sofr';
  }
};
